import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isString } from '@pct-ts/typeguard';

@Pipe({
  name: 'isString',
})
export class IsStringPipe implements PipeTransform {
  transform(value: unknown): value is string {
    return isString(value);
  }
}
